module.exports = __webpack_public_path__ + "media/images/twitter-d8bed19326af77632d84077d44b63f03.png";